<div
	[id]="screen?.id ?? screen?.['fakeId']"
	#recorderCameraBaseContainer
	[class.isFullscreen]="isThisCinemaMode"
	class="h-100 layout-container"
	[class.noScreen]="!screen?.id"
	cdkDropList
	[cdkDropListConnectedTo]="getConnectedDropListIds()"
	[cdkDropListDisabled]="!liveStreamCameraLayoutOptions.dragdropEnabled"
	(cdkDropListDropped)="onDropListDropped($event)"
	(fullscreenchange)="onFullscreenChange()"
>
	<!-- SIMSOFT-6798                                                        -->
	<!-- Disable dragging if the camera is in cinema mode or fullscreen mode -->
	<div
		class="all aspectRatio169 disableTransform"
		cdkDrag
		[cdkDragDisabled]="!screen?.id || isThisCinemaMode || isThisFullscreen"
		[cdkDragData]="screen"
		(cdkDragMoved)="onDragMove($event)"
	>
		<div class="dragCameraContainer" *cdkDragPreview id="dragCameraContainerId">
			<sim-recorder-camera-fin
				[isDragPreview]="true"
				[liveStreamCameraLayoutOptions]="liveStreamCameraLayoutOptions"
				[isSingleView]="isSingleView"
				[screen]="screen"
				[screenIndex]="screenIndex"
				[screens]="screens"
			/>
		</div>

		@if (liveStreamCameraLayoutOptions.enableControl && screen?.id !== SimUtilityService.emptyGuid()) {
			<div
				class="controlContainer"
				(click)="handleScreenClick($event)"
				[class.controlsVisible]="controlsVisible"
				(mousewheel)="zoomMouseWheel($any($event))"
			>
				@if (screen?.deviceType === DeviceType.HdmiTbsMulti && screen?.configuration?.sourceCameraNumber === null) {
					<div class="quad-grid-clickable">
						@for (i of [1, 2, 3, 4]; track $index) {
							<div class="streamSelectorArea" (click)="selectStream($event, i)"></div>
						}
					</div>
					<mat-icon
						class="subStreamVisualIndicator"
						[svgIcon]="CameraLayoutMap?.get(CameraLayoutType.Quad)?.svgs?.get(subStreamViewMode)"
					/>
				}
				@if (screen?.status === ConnectivityState.Online && screen?.deviceInformation?.batteryLevel) {
					<div class="deviceInfoContainer">
						<!--<mat-icon fontSet="fad" fontIcon="fa-battery-empty" inline style="font-size: 1.2em">
              </mat-icon>-->
						<sim-battery-status-icon [currentPercent]="screen?.deviceInformation?.batteryLevel" />
					</div>
				}
				@if (
					liveStreamCameraLayoutOptions.enableChangingPTZPositions &&
					controlsVisible &&
					selectedPTZPosition !== -1 &&
					ptzInEditMode
				) {
					<div
						appStopPropagation
						class="changePTZPosContainer ptzPosActive{{ activePTZPosition }}"
						[@zoomInOnEnter]
						[@zoomOutOnLeave]
					>
						<button mat-icon-button color="accent" appStopPropagation (click)="saveCurrentPtzPos()">
							<mat-icon fontSet="fad" fontIcon="fa-check" inline style="font-size: 1.3em" />
						</button>
						<button mat-icon-button color="warn" appStopPropagation (click)="discardCurrentPTZPos()">
							<mat-icon fontSet="fad" fontIcon="fa-times" inline style="font-size: 1.3em" />
						</button>
					</div>
				}
				<button
					[matTooltip]="
						simDeviceViewService.layout === LayoutVariants.DESKTOP ? (T.SHARED_RECORDER_CAMERA_SETTINGS | translate) : null
					"
					appStopPropagation
					matTooltipClass="accent"
					mat-icon-button
					color="accent"
					class="controlBtn"
					(click)="setControlsVisible(!controlsVisible); showCamInfo = false"
				>
					<mat-icon fontSet="fas" fontIcon="fa-cog" inline />
				</button>
				@if (controlsVisible) {
					<button
						mat-icon-button
						color="accent"
						class="showCameraInfoBtn"
						[matTooltip]="currentScreenOptions?.ipAddress"
						[class.active]="showCamInfo"
						appStopPropagation
						matTooltipClass="accent"
						[matTooltipPosition]="'below'"
					>
						<mat-icon fontSet="fas" style="font-size: 1.5em" fontIcon="fa-info-circle" inline />
					</button>
				}
				<!--
          <div
            class="zoomButtons"
            appStopPropagation
            *ngIf="screen?.deviceType === DeviceType.PTZCamera || screen?.deviceType === DeviceType.ZoomCamera"
            >
            <button
              [@zoomInOnEnter]
              [@zoomOutOnLeave]
              *ngIf="controlsVisible"
              mat-mini-fab
              color="accent"
              appStopPropagation
              (mousedown)="startZoom(-100)"
              (mouseup)="stopZoom()"
              >
              <ng-container>
                <mat-icon style="font-size: 1.4em" fontSet="fad" fontIcon="fa-search-minus" inline></mat-icon>
              </ng-container>
            </button>
            <button
              [@zoomInOnEnter]
              [@zoomOutOnLeave]
              *ngIf="controlsVisible"
              mat-mini-fab
              color="accent"
              appStopPropagation
              (mousedown)="startZoom(100)"
              (mouseup)="stopZoom()"
              >
              <ng-container>
                <mat-icon style="font-size: 1.4em" fontSet="fad" fontIcon="fa-search-plus" inline></mat-icon>
              </ng-container>
            </button>
          </div>
          -->
				@if (controlsVisible && (screen?.deviceType === DeviceType.PTZCamera || screen?.deviceType === DeviceType.ZoomCamera)) {
					<div class="zoomSliderContainer" appStopPropagation>
						<button
							[@zoomInOnEnter]
							[@zoomOutOnLeave]
							mat-mini-fab
							color="accent"
							appStopPropagation
							(mousedown)="startZoom(-100, false)"
						>
							<!--(mouseup)="stopZoom()"-->
							<ng-container>
								<mat-icon style="font-size: 1.4em" fontSet="fad" fontIcon="fa-search-minus" inline />
							</ng-container>
						</button>
						<div class="sliderStack">
							<mat-slider
								discrete
								#sliderTarget
								color="accent"
								class="zoomSliderBackground"
								[min]="0"
								[max]="100"
								[displayWith]="formatThumbLabel"
								[disabled]="true"
							>
								<input matSliderThumb #sliderThumbTarget [value]="zoomValueBackground" />
							</mat-slider>
							<mat-slider
								discrete
								#slider
								color="accent"
								class="zoomSlider"
								[min]="0"
								[max]="100"
								[displayWith]="formatThumbLabel"
							>
								<input
									matSliderThumb
									#sliderThumb
									[value]="zoomValueForeground"
									(dragStart)="sliderStartDrag($event)"
									(dragEnd)="sliderStopDrag($event)"
								/>
							</mat-slider>
						</div>
						<button
							[@zoomInOnEnter]
							[@zoomOutOnLeave]
							mat-mini-fab
							color="accent"
							appStopPropagation
							(mousedown)="startZoom(100, false)"
						>
							<!--(mouseup)="stopZoom()"-->
							<ng-container>
								<mat-icon style="font-size: 1.4em" fontSet="fad" fontIcon="fa-search-plus" inline />
							</ng-container>
						</button>
					</div>
				}
				<div class="bottomContainer" appStopPropagation>
					<div class="focusCamera" hasPermission="EnableChangingCamPosition">
						@if (screen?.configuration?.autoFocusSupported) {
							<button
								mat-icon-button
								color="accent"
								(keydown.enter)="focusCamera(screen?.id)"
								appStopPropagation
								(click)="focusCamera(screen?.id)"
								matTooltip="{{ T.SHARED_RECORDER_CAMERA_FOCUS | translate }}"
								matTooltipClass="accent"
								[matTooltipPosition]="'above'"
							>
								<mat-icon fontSet="fad" fontIcon="fa-crosshairs" inline />
							</button>
						}
						<!--<mat-icon>center_focus_strong</mat-icon>-->
						@if (screen?.deviceType === DeviceType.PTZCamera) {
							@for (i of [1, 2, 3, 4]; track i) {
								<button
									mat-mini-fab
									color="accent"
									[class.active]="activePTZPosition === i - 1 && !ptzInEditMode"
									[class.ptzTarget]="selectedPTZPosition === i - 1"
									appStopPropagation
									(click)="ptzGoToHomePosition(i)"
									(keyup.enter)="ptzGoToHomePosition(i)"
									class="small ptzPositionBtn"
									[matTooltip]="
										liveStreamCameraLayoutOptions.isStageDesigner && availablePresetNumbers.indexOf(i) < 0
											? (T.SHARED_RECORDER_CAMERA_ADD_PTZ_POSITION | translate: {number: i})
											: (T.SHARED_RECORDER_CAMERA_PTZ_POSITION | translate: {number: i})
									"
									[disabled]="!liveStreamCameraLayoutOptions.isStageDesigner && availablePresetNumbers.indexOf(i) < 0"
									matTooltipClass="accent"
									[matTooltipPosition]="'above'"
								>
									@if (!liveStreamCameraLayoutOptions.isStageDesigner || availablePresetNumbers.indexOf(i) >= 0) {
										{{ i }}
									}
									@if (liveStreamCameraLayoutOptions.isStageDesigner && availablePresetNumbers.indexOf(i) < 0) {
										<mat-icon fontSet="fa" fontIcon="fa-plus" inline />
									}
								</button>
							}
						}
						@if (screen.deviceType !== DeviceType.Standard && screen.deviceType !== DeviceType.HdmiEncoderTbs) {
							<button
								mat-mini-fab
								class="small ptzPositionBtn"
								color="accent"
								appStopPropagation
								[matTooltip]="T.SHARED_RECORDER_CAMERA_CLEAR_PTZ_POSITIONS | translate"
								matTooltipClass="accent"
								matTooltipPosition="above"
								(click)="clearCameraHomePosition()"
							>
								<mat-icon fontSet="fad" fontIcon="fa-trash-alt" inline />
							</button>
						}
						@if (screen?.rotationSupported) {
							<button
								mat-mini-fab
								class="small rotationBtn"
								color="accent"
								[matTooltip]="T.SHARED_RECORDER_CAMERA_ROTATE | translate"
								matTooltipClass="accent"
								matTooltipPosition="above"
								[disabled]="isRotating || liveStreamCameraLayoutOptions.isActiveRecording"
								appStopPropagation
								(click)="rotateCamera180()"
							>
								180°
							</button>
						}
						<!-- Disabled until further usability design
                <mat-menu #ptzMenu="matMenu" class="ptzMenuContainer">
                  <button
                    mat-menu-item
                    class="small ptzPositionBtn"
                    appStopPropagation
                    (click)="clearCameraHomePosition()"
                    >
                    <mat-icon fontSet="fad" fontIcon="fa-trash-alt" inline/>
                    <span>{{ T.SHARED_RECORDER_CAMERA_CLEAR_PTZ_POSITIONS | translate }}</span>
                  </button>
                  <button
                    *ngIf="privacyModeEnabled"
                    mat-menu-item
                    class="small ptzPositionBtn"
                    appStopPropagation
                    (click)="homePositionButtonClick()"
                    >
                    <mat-icon fontSet="fad" fontIcon="fa-home" inline></mat-icon>
                    <span>{{ T.SHARED_RECORDER_CAMERA_SET_HOME_POSITION | translate }}</span>
                  </button>
                  <button
                    *ngIf="privacyModeEnabled"
                    mat-menu-item
                    class="small ptzPositionBtn"
                    appStopPropagation
                    (click)="privacyPresetButtonClick()"
                    >
                    <mat-icon fontSet="fad" fontIcon="fa-eye-slash" inline></mat-icon>
                    <span>{{ T.SHARED_RECORDER_CAMERA_SET_PRIVACY_POSITION  | translate }}</span>
                  </button>
                </mat-menu>
                <button
                  *ngIf="screen?.deviceType === DeviceType.PTZCamera && liveStreamCameraLayoutOptions.isStageDesigner"
                  appStopPropagation
                  mat-icon-button
                  [matMenuTriggerFor]="ptzMenu"
                  matTooltipClass="primary"
                  matTooltip="{{ T.SHARED_NEW_PANEL_OPEN_MENU | translate }}"
                  >
                  <mat-icon fontSet="fas" fontIcon="fa-ellipsis-v" inline/>
                </button>
                -->
					</div>
					@if (gamepadClient?.isConnected) {
						<button mat-icon-button color="accent" style="pointer-events: none">
							<mat-icon fontSet="fad" fontIcon="fa-joystick" />
						</button>
					}
					<button
						mat-icon-button
						color="accent"
						[disabled]="isSingleView && liveStreamCameraLayoutOptions.cameraViewMode === CameraViewMode.AllScreens"
						(click)="toggleCinemaMode($event)"
						class="toggleCinemaModeBtn biggerIconButton"
						[class.active]="liveStreamCameraLayoutOptions.cameraViewMode === screenIndex + 1"
						(keyup.enter)="toggleCinemaMode()"
						matTooltip="{{ T.SHARED_RECORDER_CAMERA_TOGGLE_CINEMA | translate }}"
						matTooltipClass="accent"
						[matTooltipPosition]="'above'"
					>
						<mat-icon fontSet="far" fontIcon="fa-window-maximize" inline />
					</button>
					@if (!isTwoScreen) {
						<button
							mat-icon-button
							color="accent"
							(click)="toggleFullscreen($event)"
							matTooltip="{{ T.GLOBAL_FULLSCREEN | translate }}"
							matTooltipClass="accent"
							[matTooltipPosition]="'above'"
							class="biggerIconButton"
						>
							@if (!isThisFullscreen) {
								<mat-icon fontSet="far" fontIcon="fa-expand-wide" inline />
							}
							@if (isThisFullscreen) {
								<mat-icon fontSet="far" fontIcon="fa-compress-alt" inline />
							}
						</button>
					}
				</div>
			</div>
		}

		<!-- ---------------------------------------------------------------- -->
		<!-- See: SIMSOFT-3868, SIMSOFT-3802                                  -->
		<!-- Epiphan does not allow adding a timestamp parameter in the query -->
		<!-- ---------------------------------------------------------------- -->
		@if (currentScreenOutputFormat === VideoDestinationFormat.Mjpeg) {
			<sim-mjpeg-image [mjpegVideoOptions]="currentScreenOptions" />
		}

		@if (currentScreenOutputFormat === VideoDestinationFormat.AxisMediaStreamLibrary) {
			<sim-axis-media-stream-library-video
				[axisMediaStreamLibraryVideoOptions]="currentScreenOptions"
				[axisMediaStreamLibraryVideoIsMuted]="liveStreamCameraLayoutOptions.muted"
				[axisMediaStreamLibraryVideoStyle]="'max-width:100%;'"
			/>
		}

		@if (!settings.rtspToWebRtcSandboxStreamingModeEnabled && currentScreenOutputFormat === VideoDestinationFormat.RtspWebRtc) {
			@if (screen?.deviceType !== DeviceType.HdmiTbsMulti) {
				<sim-rtspwebrtc-video
					[sourceVideoOptions]="currentScreenOptions"
					[rtspwebrtcStreamId]="screen?.id"
					[rtspwebrtcProxyUrl]="screen?.configuration.cameraProxy"
					[rtspwebrtcProxyStatus]="screen?.proxyStatus"
					[rtspwebrtcVideoStyle]="'max-width:100%;'"
					[rtspwebrtcVideoClass]="'embed-responsive-item'"
				/>
			}

			@if (screen?.deviceType === DeviceType.HdmiTbsMulti) {
				<div>
					<sim-rtspwebrtc-video
						class="switcherVideoElement"
						[sourceVideoOptions]="currentScreenOptions"
						[rtspwebrtcStreamId]="screen?.id"
						[rtspwebrtcProxyUrl]="screen?.configuration.cameraProxy"
						[rtspwebrtcProxyStatus]="screen?.proxyStatus"
						[rtspwebrtcVideoStyle]="'max-width:100%;'"
						[rtspwebrtcVideoClass]="'embed-responsive-item'"
						[streamName]="selectedStreamName"
					>
					</sim-rtspwebrtc-video>
				</div>
			}
		}

		@if (currentScreenOutputFormat === VideoDestinationFormat.RtspWebRtc && settings.rtspToWebRtcSandboxStreamingModeEnabled) {
			<app-mse-video
				[sourceVideoOptions]="currentScreenOptions"
				[mseStreamId]="screen?.id"
				[mseProxyUrl]="screen?.configuration.cameraProxy"
				[mseProxyStatus]="screen?.proxyStatus"
				[mseVideoStyle]="'max-width:100%;'"
				[mseVideoClass]="'embed-responsive-item'"
			/>
		}

		@if (screen?.deviceType === DeviceType.PTZCamera) {
			<div class="showPtzContainer">PTZ</div>
		}
	</div>
</div>
